export var buttonDefaultTheme = {
  Root: {
    base: {},
    small: {},
    primary: {},
    primary__danger: {},
    secondary: {},
    secondary__danger: {},
    tertiary: {},
    tertiary__danger: {}
  }
};